import React, { createContext, useState } from "react";

const ReportFranchiseeContext = createContext();

const ReportFranchiseeContextProvider = ({ children }) => {
  const [cnpj, setCnpj] = useState("");
  const [reason, setReason] = useState("");
  const [family, setFamily] = useState(null);
  const [product, setProduct] = useState(null);
  const [version, setVersion] = useState(null);
  const [status, setStatus] = useState(null);
  const [segment, setSegment] = useState(null);
  const [franchisee, setFranchisee] = useState(null);
  const [valuesTable, setValuesTable] = useState([]);
  const [valuesDash, setValuesDash] = useState([]);
  const [optionsStatus, setOptionsStatus] = useState([]);

  return (
    <ReportFranchiseeContext.Provider
      value={{
        cnpj,
        setCnpj,
        reason,
        setReason,
        family,
        setFamily,
        product,
        setProduct,
        version,
        setVersion,
        status,
        setStatus,
        segment,
        setSegment,
        valuesTable,
        setValuesTable,
        franchisee,
        setFranchisee,
        valuesDash,
        setValuesDash,
        optionsStatus,
        setOptionsStatus,
      }}
    >
      {children}
    </ReportFranchiseeContext.Provider>
  );
};

export { ReportFranchiseeContextProvider, ReportFranchiseeContext };
